export default "__VITE_ASSET__KwvoycnT__"